import { Card, SxProps, Theme } from '@mui/material'
import React from 'react'

interface P {
    index?: number
    children?: JSX.Element | JSX.Element[] | string
    style?: React.CSSProperties
    sx?: SxProps<Theme>
    flex?: number
}

function HighlightCard({ style, sx, flex, children }: P) {
    return (
        <Card
            className='highlight-card'
            style={{ ...{ flex }, ...style }}
            sx={sx ?? { p: 2, height: '100%', ml: -2, mr: -2 }}>
            {children}
        </Card>
    )
}

export default HighlightCard
